// extracted by mini-css-extract-plugin
module.exports = {"base":"SelectFilter_base__DF5Lw","disableTags":"SelectFilter_disableTags__1Ka0X","vertical":"SelectFilter_vertical__1-Tzz"};